import { render } from "./DraggableChatBot.vue?vue&type=template&id=c775f00c&scoped=true"
import script from "./DraggableChatBot.vue?vue&type=script&lang=js"
export * from "./DraggableChatBot.vue?vue&type=script&lang=js"

import "./DraggableChatBot.vue?vue&type=style&index=0&id=c775f00c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c775f00c"]])

export default __exports__